import { datadogRum } from '@datadog/browser-rum';

export default () => {
  if (import.meta.env.VITE_ENVIRONMENT !== 'production') {
    return;
  }

  const initDatadog = () => {
    datadogRum.init({
      applicationId: import.meta.env.VITE_DD_APPLICATION_ID,
      clientToken: import.meta.env.VITE_DD_CLIENT_TOKEN,
      site: 'datadoghq.eu',
      service: 'proxify-ats-frontend',
      env: import.meta.env.VITE_ENVIRONMENT,
      version: import.meta.env.VITE_VERSION,
      sessionSampleRate: 100,
      sessionReplaySampleRate: 20,
      trackUserInteractions: true,
      trackResources: true,
      trackLongTasks: true,
      defaultPrivacyLevel: 'allow',
    });

    const user = localStorage.getItem('user');
    if (user) {
      datadogRum.setUser(JSON.parse(user));
    }

    datadogRum.startSessionReplayRecording();
  };

  // defer init until idle, max wait 2s
  if ('requestIdleCallback' in window) {
    window.requestIdleCallback(initDatadog, { timeout: 2000 });
  } else {
    setTimeout(initDatadog, 2000);
  }
};
